// extracted by mini-css-extract-plugin
export default {"root":"styles_root__1liLZ","wrapper":"styles_wrapper__9D9q1"};